import { Icon } from '@iconify/react';
import {
  Autocomplete,
  Box,
  Button,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { styled } from '@mui/system';
import { BackgroundModal } from 'components/CashModal/CashModal';
import React, { useEffect, useState } from 'react';
import closeIcon from '@iconify/icons-eva/close-outline';
import useDebounce from 'hook/useDebounce';
import useQuery from 'hook/useQuery';
import { API_PATH } from 'common/constants/services';
import UserSimpleInfo from 'model/UserSimpleInfo';
import { Pagination } from 'model/Pagination';
import useMutation, { METHOD } from 'hook/useMutation';
import { useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import commaNumber from 'comma-number';
import dayjs from 'dayjs';
import { RootStyle } from './style';

interface IProps {
  isOpen: boolean;
  close: () => void;
}
const Container = styled('div')`
  width: 474px;
  background-color: white;

  position: absolute;
  width: 474px;
  left: calc(50% - 474px / 2);
  top: calc(50% - 476px / 2);

  border-radius: 12px;
`;
export interface FromStoreResponse {
  year: number;
  month: number;
  ios_raw_amount: number;
  android_raw_amount: number;
}

export function MonthModal({ isOpen, close }: IProps) {
  const [date, setDate] = useState(new Date());
  const [ios, setIos] = useState('');
  const [android, setAndroid] = useState('');
  const queryClient = useQueryClient();
  const query = useQuery<FromStoreResponse>(API_PATH.FROM_STORE, {
    year: dayjs(date).year(),
    month: dayjs(date).month() + 1,
  });
  useEffect(() => {
    setIos(String(query.getQuery.data?.data.ios_raw_amount) || '');
    setAndroid(String(query.getQuery.data?.data.android_raw_amount) || '');
  }, [query.getQuery.data]);
  const addMutation = useMutation(API_PATH.FROM_STORE, {
    method: METHOD.POST,
    onSuccess: () => {
      queryClient.invalidateQueries([API_PATH.FROM_STORE]);
      queryClient.invalidateQueries([API_PATH.COACHES_SETTLEMENTS]);
      toast.success('저장완료');
    },
    onError: (e) => {
      toast.error(e.response?.data.message);
    },
  });
  useEffect(() => {
    // setIos()
    // query.getQuery.data;
  }, [query.getQuery.data]);

  return isOpen ? (
    <BackgroundModal isOpen={isOpen} onClick={close}>
      <Container
        onClick={(event: any) => {
          event.stopPropagation();
        }}
      >
        <Stack direction='row' padding={3}>
          <Box flex={1}>
            <Typography fontSize={22} fontWeight={700}>
              월별 정산
            </Typography>
          </Box>
          <Icon icon={closeIcon} fontSize={24} onClick={close} />
        </Stack>
        <Stack padding={3} direction='column' spacing={2}>
          <Box width='100%'>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                views={['month', 'year']}
                label='기준 월'
                minDate={new Date('2012-03-01')}
                maxDate={new Date('2050-06-01')}
                value={date}
                onChange={(newValue) => {
                  setDate(newValue as Date);
                }}
                renderInput={(params) => (
                  <TextField {...params} helperText={null} />
                )}
              />
            </LocalizationProvider>
          </Box>
          <Box width='100%'>
            <TextField
              fullWidth
              id='outlined-helperText'
              label='앱스토어(IOS) 판매 금액'
              defaultValue=''
              placeholder='앱스토어(IOS) 판매 금액'
              value={ios}
              onChange={(e) => setIos(e.target.value)}
            />
          </Box>
          <Box width='100%'>
            <TextField
              fullWidth
              id='outlined-helperText'
              label='플레이스토어(안드로이드) 판매 금액'
              defaultValue=''
              placeholder='안드로이드 판매 금액'
              value={android}
              onChange={(e) => setAndroid(e.target.value)}
            />
          </Box>
        </Stack>
        <Stack flexDirection='row' padding={3} gap={2} alignItems='center'>
          <Box flex={1}>
            <Typography>총 판매 금액</Typography>
          </Box>
          <Box>
            <Typography fontSize='22px' fontWeight={700}>
              {commaNumber(Number(android) + Number(ios))}원
            </Typography>
          </Box>
        </Stack>
        <Stack padding={3}>
          <Button
            variant='contained'
            fullWidth
            disabled={ios === '' || android === ''}
            onClick={async () => {
              await addMutation.mutateAsync({
                year: dayjs(date).year(),
                month: dayjs(date).month() + 1,
                ios_raw_amount: ios,
                android_raw_amount: android,
              });
              close();
            }}
          >
            입력하기
          </Button>
        </Stack>
      </Container>
    </BackgroundModal>
  ) : null;
}
